import Breadcrumbs from "components/breadcrumbs";
import ParentOrganismRooms from "components/parentOrganismRooms";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";

const ParentClasses = () => {

    const auth = useSelector((state: RootStateOrAny) => state.auth);
    const { user } = useSelector((state) => state.auth);

    return (
        <React.Fragment>
            <Breadcrumbs isRooms isBack={false} />
            <ParentOrganismRooms />
        </React.Fragment>
    );

}

export default ParentClasses;